import { combineReducers, configureStore } from '@reduxjs/toolkit';

import AdminReducer from './admin/AdminReducer';
import CommonReducer from './auth/CommonReducer';
import customerReducer from './customer/CustomerReducer';
const rootReducer = combineReducers({
  admin: AdminReducer,
  customer: customerReducer,
  common: CommonReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
